<template>
  <div>
    <vx-card title="Tambah Cashflow" subtitle="Catat kas masuk atau keluar pada Buku Kas tanpa membuat Journal Voucher">
      <div slot="no-body" class="p-6">
        <vs-alert v-if="saveError" color="warning" class="mb-6" role="alert">{{ saveError }}</vs-alert>

        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <label class="text-sm opacity-75">Jenis kas</label>
            <div class="flex flex-wrap mt-2 mb-5">
              <vs-radio vs-value="debit" v-model="type" class="mr-6">Kas Masuk</vs-radio>
              <vs-radio vs-value="credit" v-model="type">Kas Keluar</vs-radio>
            </div>
            <vs-input v-model="date" type="date" :min="`${selectedYear}-01-01`" :max="`${selectedYear}-12-31`" label="Tanggal" class="w-full mb-5" />
            <vs-input v-model.trim="number" type="number" min="1" label="Nomor voucher awal (opsional, hanya untuk voucher pertama di buku kas ini)" class="w-full mb-5" />
            <vs-input v-model.trim="paidTo" label="Diterima dari / dibayarkan kepada" class="w-full mb-5" maxlength="191" />
            <label class="text-sm opacity-75">Catatan (opsional)</label>
            <vs-textarea v-model="notes" class="w-full mt-2" maxlength="191" />
          </div>

          <div class="vx-col w-full md:w-1/2">
            <label class="text-sm opacity-75">Rincian transaksi</label>
            <div v-for="(item, index) in items" :key="index" class="flex flex-wrap items-end mt-3">
              <vs-input v-model.trim="item.title" label="Keterangan" class="flex-1 mr-3" />
              <vs-input v-model.number="item.amount" type="number" min="1" step="1" label="Jumlah (Rp)" class="mr-3" />
              <vs-button v-if="items.length > 1" color="secondary" type="border" icon-pack="feather" icon="icon-trash" @click="items.splice(index, 1)" aria-label="Hapus rincian" />
            </div>
            <vs-button color="secondary" type="border" icon-pack="feather" icon="icon-plus" class="mt-4" @click="items.push({ title: '', amount: null })">Tambah rincian</vs-button>
            <p class="mt-6 font-semibold">Total: Rp {{ total.toLocaleString('id-ID') }}</p>
          </div>
        </div>

        <div class="flex flex-wrap mt-8">
          <vs-button color="primary" type="filled" :disabled="isSaving" @click="saveCashFlow">{{ isSaving ? 'Menyimpan...' : 'Simpan Cashflow' }}</vs-button>
          <vs-button color="secondary" type="border" class="ml-3" :disabled="isSaving" @click="goBack">Batal</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moment from 'moment'
import moduleCashFlow from '@/store/cashflows/moduleCashFlow.js'

export default {
  data () {
    const selectedYear = Number(localStorage.getItem('selectedYear')) || new Date().getFullYear()
    return {
      selectedYear,
      type: 'debit',
      date: selectedYear === new Date().getFullYear() ? moment().format('YYYY-MM-DD') : `${selectedYear}-01-01`,
      paidTo: '',
      number: '',
      notes: '',
      items: [{ title: '', amount: null }],
      isSaving: false,
      saveError: ''
    }
  },
  computed: {
    total () {
      return this.items.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    }
  },
  created () {
    if (!moduleCashFlow.isRegistered) {
      this.$store.registerModule('cashFlow', moduleCashFlow)
      moduleCashFlow.isRegistered = true
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'cash-book-cashflows', params: { cashbookType: this.$route.params.cashbookType, cashbookId: this.$route.params.cashbookId } })
    },
    async saveCashFlow () {
      if (this.isSaving) return
      this.saveError = ''
      const validDate = moment(this.date, 'YYYY-MM-DD', true).isValid() && Number(this.date.slice(0, 4)) === this.selectedYear
      const validItems = this.items.length > 0 && this.items.every(item => item.title && item.title.trim() && Number.isSafeInteger(Number(item.amount)) && Number(item.amount) > 0)
      if (!validDate || !this.paidTo || !validItems) {
        this.saveError = 'Isi tanggal pada tahun buku aktif, pihak terkait, dan setiap rincian dengan jumlah bulat lebih dari nol.'
        return
      }

      this.isSaving = true
      try {
        await this.$store.dispatch('cashFlow/addCashFlow', {
          cashbook_id: this.$route.params.cashbookId,
          type: this.type,
          date: this.date,
          paid_to: this.paidTo,
          number: this.number ? String(this.number) : null,
          notes: this.notes || null,
          items: JSON.stringify(this.items.map(item => ({ title: item.title.trim(), amount: Number(item.amount) })))
        })
        this.$vs.notify({ color: 'primary', title: 'Berhasil', text: 'Cashflow berhasil ditambahkan.' })
        this.goBack()
      } catch (error) {
        const data = error.response && error.response.data
        const errors = data && data.errors
        this.saveError = errors ? Object.values(errors).reduce((messages, value) => messages.concat(value), [])[0] : (data && data.message) || 'Cashflow gagal disimpan. Coba lagi.'
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>
